const CheckoutStyles = {
    baseStyle: {
        checkoutHeading: {
            fontSize: '34px',
            fontWeight: '400',
            color: 'black.100',
            display: {base: 'none', lg: 'block'},
            marginBottom: '20px'
        },
        orderSummaryContainer: {
            backgroundColor: 'transparent',
            maxWidth: '384px',
            padding: '15px',
            spacing: 4
        },
        checkoutContainer: {
            maxWidth: {base: '100%', md: '970px', lg: '1170px', xl: '1290px'},
            backgroundColor: 'white',
            padding: {
                base: '30px 20px',
                xl: '60px'
            }
        },
        contactInfoCheckbox: {
            display: 'grid',
            height: 'fit-content',
            alignItems: 'center',
            bg: 'white',
            minHeight: '56px',
            padding: '15px',
            borderRadius: '10px',
            border: '1px solid #EDE8E3',
            sx: {
                '.chakra-checkbox__label': {
                    color: 'black.100',
                    fontSize: '14px',
                    fontFamily: 'body',
                    fontWeight: '400'
                }
            },
            backgroundColor: 'gray.50'
        },
        contactInfoCheckboxExpandable: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            bg: 'white',
            height: 'auto',
            minHeight: '56px',
            py: '15px',
            px: '15px',
            borderRadius: '10px',
            border: '1px solid #EDE8E3',
            sx: {
                '.chakra-checkbox__label': {
                    color: 'black.100',
                    fontSize: '14px',
                    fontFamily: 'body',
                    fontWeight: '400'
                }
            },
            backgroundColor: 'gray.50'
        },
        contactInfoCheckboxSpacer: {
            visibility: 'hidden',
            fontSize: '16px',
            fontFamily: 'body',
            mb: '4px'
        },
        contactInfoHelpText: {
            fontSize: '13px',
            fontFamily: 'body',
            fontWeight: '400',
            color: 'gray.650',
            mt: '5px',
            letterSpacing: '0.065px'
        },
        contactInfoToggleConsent: {
            mt: '10px',
            borderTop: '0px solid'
        },
        addressPreviewContainer: {
            mt: 4,
            bg: 'gray.50',
            borderRadius: '3px',
            px: '20px',
            py: '16px'
        },
        addressPreviewName: {
            fontFamily: 'body',
            fontSize: '16px',
            fontWeight: '400',
            color: 'black.100'
        },
        addressPreviewText: {
            fontFamily: 'body',
            fontSize: '16px',
            fontWeight: '300',
            color: 'black.100'
        },
        checkoutOrderSummaryContainer: {
            backgroundColor: 'white',
            padding: {base: '0px 15px', lg: '15px'},
            spacing: 4
        },
        loginPromptText: {
            fontFamily: 'body',
            fontWeight: '300',
            fontSize: '16px'
        },
        loginPromptLink: {
            fontWeight: '400',
            textDecoration: 'underline',
            color: 'black.100'
        },
        loginPromptSuffix: {
            color: 'black.100'
        },
        emailSignupLabel: {
            fontSize: '14px',
            fontFamily: 'body',
            fontWeight: '400',
            color: 'black.100'
        },
        emailSignupPrivacyLink: {
            textDecoration: 'underline',
            color: 'black.100',
            fontSize: '11px',
            fontWeight: '300',
            marginLeft: '25px'
        },
        shippingSummaryContainer: {
            border: '1px solid',
            borderColor: 'gray.500',
            bg: '#F9F8F7',
            borderRadius: '6px',
            padding: '30px !important',
            boxShadow: 'none',
            sx: {
                '> .chakra-stack': {
                    gap: '30px !important'
                },
                '.chakra-heading': {
                    fontFamily: 'cormorant',
                    fontWeight: '400',
                    color: 'black.100',
                    fontSize: {base: '25px', lg: '26px'},
                    lineHeight: 'normal'
                },
                'button[aria-label]': {
                    textDecoration: 'underline',
                    fontSize: '16px',
                    color: 'black.100',
                    fontWeight: '400',
                    fontFamily: 'body'
                }
            }
        },
        shippingSummaryName: {
            fontFamily: 'body',
            fontSize: '16px',
            textTransform: 'capitalize',
            fontWeight: '400',
            color: 'black.100'
        },
        shippingSummaryText: {
            fontFamily: 'body',
            fontSize: '16px',
            textTransform: 'capitalize',
            fontWeight: '300',
            color: 'black.100'
        },
        findAddressCTA: {
            fontSize: '16px',
            fontWeight: '400',
            fontFamily: 'body',
            color: 'black.100',
            textDecoration: 'underline',
            lineHeight: '25px',
            letterSpacing: '0.08px'
        },
        addressFinderContainer: {
            position: 'relative'
        },
        searchIcon: {
            position: 'absolute',
            top: '20px',
            left: '15px',
            zIndex: '1'
        },
        toggleHeading: {
            as: 'h2',
            fontFamily: 'heading',
            fontWeight: '400',
            fontSize: {base: '25px', md: '26px'},
            color: 'black',
            letterSpacing: '0.13px'
        },
        toggleBackground: {
            backgroundColor: 'gray.100',
            border: '1px solid',
            borderColor: 'gray.500',
            borderRadius: {base: '0px !important', lg: '6px !important'},
            padding: '30px'
        },
        contactDetails: {
            color: 'black.100',
            fontSize: '16px',
            fontWeight: '300',
            letterSpacing: '0.08px',
            lineHeight: '25px',
            transition: 'color 0.2s, ease'
        },
        moreInformation: {
            textDecoration: 'underline',
            textUnderlineOffset: '4px',
            fontWeight: '400',
            _hover: {
                color: 'teal.600'
            }
        },
        expressCheckoutWrapper: {
            gap: '20px',
            marginLeft: {base: '15px', lg: '0px'},
            marginRight: {base: '15px', lg: '0px'},
            sx: {
                '.paypal-container-wrapper, .apple-pay-wrapper': {
                    width: '50%'
                },
                '.paypal-container-wrapper': {
                    height: '50px'
                },
                '.adyen-checkout__paypal__button': {
                    marginBottom: '0px'
                }
            }
        },
        expressCheckoutTermsAndPrivacyText: {
            color: 'black.100',
            fontSize: '13px',
            fontWeight: '300',
            lineHeight: '22px',
            sx: {
                a: {
                    textDecoration: 'underline',
                    textUnderlineOffset: '4px',
                    color: 'black',
                    _hover: {
                        color: 'teal.600 !important'
                    }
                }
            }
        },
        expressPaymentButtons: {
            display: 'inline-flex',
            gap: '20px',
            sx: {
                iframe: {
                    borderRadius: '10px'
                }
            }
        },
        paymentErrorMessage: {
            color: 'red.400',
            fontSize: '16px',
            fontWeight: '300',
            fontFamily: 'body',
            width: '100%'
        },
        generalErrorMessage: {
            color: 'red.400',
            fontSize: '16px',
            fontWeight: '300',
            fontFamily: 'body',
            width: '100%'
        },
        placeOrderContainer: {
            maxWidth: '100%',
            textAlign: {base: 'center', lg: 'left'},
            margin: {base: 'auto', lg: '0px'}
        },
        aggrementText: {
            color: 'black.100',
            fontSize: '13px',
            letterSpacing: '0.065px',
            margin: {
                base: '0px auto 30px auto',
                lg: '20px auto 30px auto'
            },
            fontWeight: '300'
        },
        paymentStack: {
            display: 'inline-flex',
            flexDirection: 'row',
            gap: '40px',
            sx: {
                '.address-name-text': {
                    fontWeight: '300 !important'
                }
            }
        },
        cardLastDigitsWrapper: {
            display: 'inline-flex',
            gap: '6px'
        },
        cardNumber: {
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '25px',
            textTransform: 'capitalize',
            color: 'black.100'
        },
        expiryMonth: {
            fontWeight: 300,
            fontSize: '16px',
            lineHeight: '25px',
            color: 'black.100'
        },
        paymentCardStack: {
            display: 'grid',
            gap: '0px',
            alignItems: 'self-start'
        },
        paymentCardSummary: {
            alignItems: 'baseline',
            gap: '10px',
            flexDirection: 'row'
        },
        boltSubOptionLabel: {
            display: 'inline-flex',
            gap: '25px'
        },
        boltPaymentStack: {
            gap: '30px',
            sx: {
                label: {
                    alignItems: 'center',
                    gap: '25px'
                },
                'label[for="BOLT_PAY"]': {
                    gap: '20px !important',
                    '.chakra-radio__label': {
                        display: 'inline-flex',
                        gap: '21px',
                        borderRadius: '3px'
                    }
                },
                '.bolt-card-payment__radio, .bolt-card-payment__methods__radio, .bolt-card-payment__new-card__radio':
                    {
                        width: '27px !important',
                        height: '27px !important'
                    },
                '.chakra-radio__label, span': {
                    margin: '0px'
                },
                '.chakra-select__wrapper': {
                    paddingLeft: '53px'
                },
                '.chakra-select__icon-wrapper': {
                    top: '62% !important'
                },
                '.bolt-card-payment__new-card-box label': {
                    alignItems: 'flex-start !important'
                }
            }
        },
        boltCardPayment: {
            background: 'gray.50',
            marginBottom: '-10px',
            border: '1px solid var(--chakra-colors-gray-30)',
            padding: '26px 16px 26px 16px !important',
            borderRadius: '5px',
            transition: 'margin .15s cubic-bezier(.4, 0, .2, 1) 0ms, opacity .3s ease-out'
        },
        boltPaymentMethods: {
            marginLeft: {base: '30px', lg: '45px'}
        },
        boltLabelText: {
            fontSize: '18px',
            fontWeight: '500',
            letterSpacing: '0.09px',
            color: 'black.100',
            lineHeight: '25px'
        },
        selectField: {
            height: '56px',
            maxWidth: '100%'
        },
        creditCardIcon: {
            width: '60px',
            height: '40px',
            borderRadius: '3px',
            alt: 'Credit Card'
        },
        giftWrapSummary: {
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            pt: '30px',
            fontSize: '16px',
            fontWeight: 300,
            lineHeight: '25px',
            color: 'black.100'
        },
        boltCustomerDetails: {
            position: 'relative',
            pl: '28px',
            margin: '10px 0px 10px 0px',
            _before: {
                content: '""',
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: 0,
                width: '7px',
                background: 'customerDetailsBorder',
                borderRadius: '0px'
            }
        },
        boltCustomerDetailsHeading: {
            fontSize: '26px',
            color: 'black.100',
            fontWeight: '400',
            lineHeight: '22px',
            fontFamily: 'heading'
        },
        boltCustomerDetailsEmailLogout: {
            mt: '15px',
            gap: '10px'
        },
        boltCustomerDetailsEmail: {
            fontSize: '14px',
            fontWeight: '300',
            lineHeight: '22px',
            color: 'black.100',
            fontFamily: 'body'
        },
        boltCustomerDetailsLogout: {
            fontSize: '14px',
            fontWeight: '400',
            _hover: {
                color: 'teal.600'
            },
            transition: 'color, 0.3s ease',
            lineHeight: '22px',
            color: 'black.100',
            textDecoration: 'underline',
            textUnderlineOffset: '4px',
            fontFamily: 'body'
        }
    }
}

export default CheckoutStyles
